export const CommitteesPage = () => (
    <section className="container mx-auto px-6 py-16" style={{ backgroundColor: 'var(--color-body-bg)', color: 'var(--color-body-text)' }}>
        <h2 className="mb-4 text-4xl font-bold text-center animate-fade-in" style={{ color: 'var(--color-section1-heading)' }}>Committees</h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 animate-fade-in delay-100">
            {[1, 2, 3, 4, 5, 6].map(i => (
                <div key={i} className="p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300" style={{ backgroundColor: 'var(--color-section1-card-bg)', color: 'var(--color-section1-card-text)' }}>
                    <h3 className="text-2xl font-semibold mb-3" style={{ color: 'var(--color-section1-heading)' }}>Committee {i}</h3>
                    <p className="leading-relaxed">
                        Committees for <b>EthosMUN</b> 2026 will be announced shortly
                    </p>
                </div>
            ))}
        </div>
    </section>
);